import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./alert-dialog"
import { Button } from "./button"
import { useStore } from '@/store/useStore';
import { X } from 'lucide-react';

interface AlertProps {
  open: boolean;
  setOpen: () => void;
  onClick: () => void;
}

const Alert = ({ open, setOpen, onClick }: AlertProps) => {
  const generateWeeklyPlan = useStore(state => state.generateWeeklyPlan);

  const handleMealGeneration = (mergeAction: 0 | 1 | 2) => {
    generateWeeklyPlan(mergeAction)
    onClick();
  }
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        {/* Close (X) button */}
        <button
          onClick={() => setOpen()}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <X className="w-6 h-6"/>
        </button>
        <AlertDialogHeader>
          <AlertDialogTitle>Weekly Meal Plan Options</AlertDialogTitle>
          <AlertDialogDescription>
            Would you like to create a new weekly plan or fill in the gaps where meals haven't been added yet?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className='bg-purple' onClick={() => handleMealGeneration(2)}>Fill Missing Meals</AlertDialogCancel>
          <AlertDialogAction className='bg-[#5CE1E695] hover:bg-secondary/90' onClick={() => handleMealGeneration(1)}>Create New Plan</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default Alert;